module.exports = __webpack_public_path__ + "img/blog6-logo-3.01355853.webp";